export const API_URL = "https://walking-on-a-planet-server.herokuapp.com";
// export const API_URL = "http://localhost:3001";